import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { publicApi } from "@/lib/publicApi";
import { PageHero } from "@/components/public/Primitives";
import CTASection from "@/components/public/CTASection";
import SEO from "@/components/public/SEO";
import { getLucideIcon } from "@/lib/iconMap";
import { ctaForServiceSlug, CTA } from "@/lib/ctas";
import AuditReassurance from "@/components/public/AuditReassurance";

export default function Services() {
    const [services, setServices] = useState([]);
    useEffect(() => {
        publicApi.get("/services").then((r) => {
            const sorted = (r.data || []).slice().sort((a, b) => (a.order ?? 999) - (b.order ?? 999));
            setServices(sorted);
        }).catch(() => {});
    }, []);

    return (
        <div data-testid="services-page">
            <SEO
                title="Services for UK small businesses | Omega IT"
                description="Ordering websites, booking systems, WhatsApp flows, admin dashboards, SEO and marketing designs. Priced up front, built for UK small businesses."
            />
            <PageHero
                eyebrow="— WHAT WE DO"
                title="Eight things we build for small businesses."
                subtitle="Pick one, or stack them into a proper system. Priced up front, in writing, before we start."
                primaryCta={{ to: CTA.AUDIT.href, label: CTA.AUDIT.label }}
            >
                <AuditReassurance />
            </PageHero>
            <section className="px-5 sm:px-8 lg:px-12 py-16">
                <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {services.map((s) => (<ServiceIndexCard key={s.id} service={s} />))}
                </div>
            </section>
            <CTASection />
        </div>
    );
}

function ServiceIndexCard({ service }) {
    const Icon = getLucideIcon(service.icon);
    const cta = ctaForServiceSlug(service.slug);
    const orderLabel = String(service.order ?? "•").padStart(2, "0");
    return (
        <div
            className="module reveal"
            data-testid={`service-index-card-${service.slug}`}
            style={{ display: "flex", flexDirection: "column" }}
        >
            <Link
                to={`/services/${service.slug}`}
                className="flex-1"
                data-testid={`service-index-link-${service.slug}`}
                style={{ display: "block", color: "inherit" }}
            >
                <span className="ico"><Icon className="w-4 h-4" /></span>
                <div className="mtag mt-5">{orderLabel} / {service.title.split(" ")[0]}</div>
                <h3 style={{ color: "var(--text)" }}>{service.title}</h3>
                <p style={{ fontSize: "14.5px", marginTop: "10px", lineHeight: 1.55, color: "var(--muted)" }}>
                    {service.short_description}
                </p>
            </Link>
            <div style={{ marginTop: 18, borderTop: "1px solid var(--line-soft)", paddingTop: 16 }}>
                <Link
                    to={cta.href}
                    className="btn-primary"
                    data-testid={`service-index-cta-${service.slug}`}
                    style={{ padding: "10px 16px", fontSize: 13.5 }}
                >
                    {cta.label} →
                </Link>
                {cta.key === "audit" && <AuditReassurance />}
            </div>
        </div>
    );
}
